"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PRODUCT_HISTORY_PAGE_LIMIT = 20;
var PURCHASED_PRODUCTS_ERROR = 'Error getting information about purchased products';
var PRODUCT_TRANSACTIONS_ERROR = 'Error getting information about transactions for this product';
var _require = require('underscore'),
  last = _require.last,
  first = _require.first;
var OrgEntitlements = /*#__PURE__*/function () {
  OrgEntitlements.$inject = ["$rootScope", "$scope", "$q", "entitlementsService", "userService"];
  /* @ngInject */
  function OrgEntitlements($rootScope, $scope, $q, entitlementsService, userService) {
    _classCallCheck(this, OrgEntitlements);
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.entitlementsService = entitlementsService;
    this.transactionViewPool = true;
    this.isUserSuperAdmin = userService.isSuperAdmin();
  }

  /**
   * Initializes data and adds event listener for next and previous page loading
   *
   */
  return _createClass(OrgEntitlements, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.loading = true;
      this.getPurchaseOrganizationProducts().then(function (purchasedProducts) {
        return _this.purchasedProducts = purchasedProducts;
      }).catch(function (error) {
        console.error(error);
        _this.purchasedProductsError = PURCHASED_PRODUCTS_ERROR;
      }).finally(function () {
        return _this.loading = false;
      });
      this.$scope.$on('LOAD_PREVIOUS_TRANSACTION_PAGE', function (event, productName) {
        var _iterator = _createForOfIteratorHelper(_this.purchasedProducts),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var product = _step.value;
            if (product.name === productName) {
              var firstTransaction = first(product.transactionsPage.items);
              _this.getOrganizationProductTransactions(product, {
                startAt: firstTransaction._id
              }).catch(function /* error */
              () {
                return _this.$rootScope.setFlashMessage(PRODUCT_TRANSACTIONS_ERROR, 'danger');
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      this.$scope.$on('LOAD_NEXT_TRANSACTION_PAGE', function (event, productName) {
        var _iterator2 = _createForOfIteratorHelper(_this.purchasedProducts),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var product = _step2.value;
            if (product.name === productName) {
              var lastTransaction = last(product.transactionsPage.items);
              _this.getOrganizationProductTransactions(product, {
                endAt: lastTransaction._id
              }).catch(function /* error */
              () {
                return _this.$rootScope.setFlashMessage(PRODUCT_TRANSACTIONS_ERROR, 'danger');
              });
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    }

    /**
     * Fetches the purchased products for the current organization
     *
     * @returns {Promise} - the purchased products by the organization
     */
  }, {
    key: "getPurchaseOrganizationProducts",
    value: function getPurchaseOrganizationProducts() {
      if (this.purchasedProducts) {
        return this.$q.resolve(this.purchasedProducts);
      }
      return this.entitlementsService.getPurchaseOrganizationProducts(this.organisation._id);
    }

    /**
     * Fetches the transactions history for a specific product for the current organization,
     * and assigns the transaction history to 'product.transactionsPage'. Supports pagination
     *
     * @param {number} productIndex - The index of the product in the this.purchasedProducts array
     * @param {object} page - The object specifying the pagination
     */
  }, {
    key: "getOrganizationProductTransactions",
    value: function getOrganizationProductTransactions(product) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        first: true
      };
      if (product.transactionsLoading) return;
      product.transactionsLoading = true;
      return this.entitlementsService.getOrganizationProductTransactions(this.organisation._id, product.productCodes, [this.entitlementsService.TYPE_ACCOUNT, this.entitlementsService.TYPE_TRANSACTION, this.entitlementsService.TYPE_EXPIRED], null, Object.assign(page, {
        limit: PRODUCT_HISTORY_PAGE_LIMIT
      })).then(function (transactionsPage) {
        product.transactionsPage = transactionsPage;
        product.transactionsLoading = false;
      }).finally(function () {
        return product.transactionsLoading = false;
      });
    }

    /**
     * Expands/collapses the product transactions table. Fetches product transactions if missing
     *
     * @param {Event} event - The click event
     * @param {object} clickedProduct - The product that was clicked
     */
  }, {
    key: "onProductClick",
    value: function onProductClick(event, clickedProduct) {
      var _this2 = this;
      if (event) event.preventDefault();
      if (!clickedProduct.transactionsPage) {
        this.getOrganizationProductTransactions(clickedProduct).catch(function () {
          return _this2.productTransactionsError = PRODUCT_TRANSACTIONS_ERROR;
        });
      }
      this.purchasedProducts = this.purchasedProducts.map(function (product) {
        return Object.assign(product, {
          expanded: clickedProduct.name === product.name ? !product.expanded : false
        });
      });
    }

    /**
     * SuperAdmin flush cache
     */
  }, {
    key: "flushCache",
    value: function flushCache() {
      var _this3 = this;
      if (this.flushing) {
        return;
      }
      this.flushing = true;
      return this.entitlementsService.flushCache().finally(function () {
        return _this3.flushing = false;
      });
    }

    /**
     * Toggle between view of all transactions and grouped view
     */
  }, {
    key: "toggleTransactionView",
    value: function toggleTransactionView() {
      this.transactionViewPool = !this.transactionViewPool;
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlements', ['backstage.services']).component('bsOrgEntitlements', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlements/org-entitlements.html',
  bindings: {
    organisation: '<'
  },
  controllerAs: 'vm',
  controller: OrgEntitlements
}).name;